






























import Vue from 'vue'
import Component from 'vue-class-component'
import LeafletMap from '@app/componentlib/src/views/components/location-components/LeafletMap.vue'
import RadiusSlider from '@app/componentlib/src/views/components/location-components/RadiusSlider.vue'
import { ISettingsItem, IUserInfo } from '@app/componentlib/common/types/JobSearchTypes'
import { IMapInformation, IRegion } from '@app/componentlib/common/types/LocationTypes'
import { AppModule } from '@app/componentlib/src/store/modules/app'
import { LocationModule } from '@app/componentlib/src/store/modules/locationdata'

@Component<MapView>({
  components: {
    LeafletMap,
    RadiusSlider
  },
  props: {
    isActive: Boolean,
    mapInformation: Object,
    userInfo: Object,
    countryToInit: String,
    canSearchFromMap: Boolean,
    settings: Object
  }
})

export default class MapView extends Vue {
  /**
   * Props variables
   */
  isActive: boolean = false
  userInfo: IUserInfo | undefined
  countryToInit: string | undefined
  settings: ISettingsItem | undefined
  canSearchFromMap: boolean = false

  /**
   * Component state variables
   */
  mapInformation!: IMapInformation

  /**
   * Lifecycle
   */
  mounted() {
    window.addEventListener('keydown', (e) => {
      if (e.key === "Enter" && this.isActive) {
        this.startSearchFromMap()
      }
    })
  }

  /**
   * Getters
   */
  get t (): any {
    return AppModule.translations
  }

  get location (): IRegion {
    return LocationModule.locations[0]
  }


  /**
   * Methods
   */
  away() {
    this.$emit('closeTypeahead', false)
  }

  searchFromMapClick() {
    if (this.canSearchFromMap)
      this.$emit('startSearchFromMap')
  }

  radiusValueChanged(radius: number) {
    if (this.location === undefined) return

    this.mapInformation.Radius = radius
    let tempRegion = this.location
    tempRegion.radius = radius
    tempRegion.mapViewText = tempRegion.postal + " " + tempRegion.city + " - Radius: " + tempRegion.radius + " km"
    LocationModule.setLocation([tempRegion])
  }

  async startSearchFromMap() {
    if (this.location === undefined) {
      await this.setLocationOnClose()
    }
    this.$emit('startSearchFromMap')
    this.away()
  }
  async setLocationOnClose() {
    const { Lat, Lng } = this.mapInformation
    await this.getLocationFromCordinates(Lat, Lng)
  }
  async getLocationFromCordinates(lat: number, lng: number) {
    if (lat && lng) {
      await LocationModule.GetAddressFromCoordinates({lat: lat, lon: lng}).then((data) => {
        if (data !== undefined) LocationModule.setLocation([data])
      })
    }
  }
}
